// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"09c396f5","905":"ae2dca9a"}[chunkId] + ".js";
};